import Component from 'D:/AUTOMFL/UniApp/uniAdmin/components/uni-sub-menu/uni-sub-menu.vue'
wx.createComponent(Component)